@let location = location$ | async;
<a nz-button nzType="default" nzBlock [href]="'tel:' + location?.phone" class="!bg-neutral-100 !border-none">
  <span nz-icon nzType="phone" nzTheme="fill"></span>
  <span nz-typography>{{ location?.phone | phoneFormat: location?.countryCode }}</span>
</a>

@if (location.onlineProfiles?.whatsapp || location.onlineProfiles?.instagram || location.onlineProfiles?.facebook) {
  <nz-divider nzPlain [nzText]="'shared.labels.or' | translate"></nz-divider>
  <div class="flex flex-col gap-2">
    @if (location.onlineProfiles?.whatsapp) {
      <a
        nz-button
        nzType="default"
        class="w-full"
        [href]="'https://wa.me/' + location.onlineProfiles!.whatsapp!.replace('+', '')"
        target="_blank"
      >
        <nz-icon nzType="whatsapp" nzTheme="fill" />
        {{ 'pages.request-appointment.social.whatsapp' | translate }}
      </a>
    }

    @if (location.onlineProfiles?.instagram) {
      <a
        nz-button
        nzType="default"
        class="w-full"
        [href]="'https://ig.me/m/' + location.onlineProfiles?.instagram"
        target="_blank"
      >
        <!-- nz-icon breaks the gradient of this svg on mobile -->
        <img src="assets/instagram.svg" width="14" height="14" alt="" aria-hidden="true" class="!inline !me-2" />
        {{ 'pages.request-appointment.social.instagram' | translate }}
      </a>
    }

    @if (location.onlineProfiles?.facebook) {
      <a
        nz-button
        nzType="default"
        class="w-full"
        [href]="'https://m.me/' + location.onlineProfiles?.facebook"
        target="_blank"
      >
        <nz-icon nzType="messenger" nzTheme="fill" />
        {{ 'pages.request-appointment.social.messenger' | translate }}
      </a>
    }
  </div>
}
